import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import App from './App--OLD';
import './scss/styles.scss';
import reportWebVitals from './reportWebVitals';

// renders twice for testing
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// // renders once
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <App />
// );


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
